import * as prismic from "@prismicio/client";

// -- Prismic API endpoint
const apiEndpoint = "https://illinois-squeez.cdn.prismic.io/api/v2";
// -- Access Token if the repository is not public
const accessToken =
  "MC5hSGtaSkJFQUFDQUFBVUI4.dG_vv73vv70xW--_vWZ577-9VmHvv73vv73vv70YQBgeW3Hvv71GZhnvv73vv70lal9x77-9";
// -- Prismic Client
const PrismicClient = prismic.createClient(apiEndpoint, { accessToken });

export default PrismicClient;
